module.exports = __webpack_public_path__ + "img/ball2_dn.85fa0541.png";